/* eslint-disable import/prefer-default-export */
import { toast } from 'react-toastify';
import Api from '../lib/api/api';
import { ERROR_MESSAGE } from '../lib/constants';

// get System Logs data
export const getSystemLogs = (token, pagination, filters) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.systemLogs(pagination, filters);
    dispatch({
      type: 'SYSTEM_LOGS_SUCCESS',
      data,
    });
    return data;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'SYSTEM_LOGS_ERROR',
    });
    return false;
  }
};

// add System Logs data
export const addSystemLogs = (token, body) => async dispatch => {
  const api = new Api(token);
  try {
    const actions = {
      actions: [body],
    };
    const data = await api.boxes.addSystemLogs(actions);
    dispatch({
      type: 'ADD_SYSTEM_LOGS_SUCCESS',
      data,
    });
    return data;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ADD_SYSTEM_LOGS_ERROR',
    });
    return false;
  }
};
